import { COLORS } from '../Theme';
import { makeStyles } from '@material-ui/core/styles';
import {
    Button,
    Card,
    CardActions,
    CardHeader,
    CardMedia,
    createStyles,
    IconButton,
    Theme,
    Typography,
} from '@material-ui/core';

import {
    member as v_member,
    basic,
    Values,
    member,
} from '../../request/values';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            width: '100vw',
            height: 'auto',
            // height: '32vh',
            border: 'solid 1px #d3d3d3',
            boxShadow: 'none',
            paddingTop: '1vh',
            paddingBottom: '1vh',
            [theme.breakpoints.up('md')]: {
                paddingTop: '2.5vh',
                paddingBottom: '2.5vh',
            },
        },
        cardHeader: {
            padding: '0 4vw',
            '& span > p': {
                fontSize: '3vw',
                color: `${COLORS.BROWNISH_GREY}`,
                fontFamily: 'NanumR',
                fontWeight: 'bold',
                [theme.breakpoints.up('md')]: {
                    fontSize: '2vw',
                },
            },
            // "& span > #price": {
            //     fontSize: '15px',
            //     fontWeight: 'bold',
            //     color: `${COLORS.CHARCOAL_GREY}`,
            // },
            '& .MuiCardHeader-action': {
                marginTop: 0,
            },
            '& #price': {
                fontSize: '3vw',
                // fontFamily: 'NanumR',
                fontWeight: 'bold',
                color: `${COLORS.CHARCOAL_GREY}`,
                [theme.breakpoints.up('md')]: {
                    fontSize: '2.4vw',
                },
            },
            alignItems: 'flex-start',
        },
        media: {
            height: '23vh',
            width: '100%',
            //margin: 'auto',
            margin: '3vw 0',
            backgroundSize: 'contain',
        },
        cardAction: {
            padding: '0 4vw',
            justifyContent: 'space-evenly',
            //paddingBottom: 0,
        },

        button: {
            width: '42%',
            height: 'auto',
            color: `${COLORS.WHITE}`,
            padding: '0',
            ...theme.typography.subtitle2, // fontSize: '3.6vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            [theme.breakpoints.up('md')]: {
                width: '42%',
                height: 'auto',
                color: `${COLORS.WHITE}`,
                ...theme.typography.subtitle2, // fontSize: '3.6vw',
                fontFamily: 'NanumB',
                fontWeight: 'bold',
                padding: '22px',
            },
        },
        manualButton: {
            backgroundColor: `${COLORS.WATER_BLUE}`,
            width: '42vw',
            height: '3.5vh',
        },
        productionButton: {
            backgroundColor: `${COLORS.PUMPKIN}`,
        },
    })
);

interface iProductItem {
    productNum: number;
    productName: string;
    productImage: string;
    productMenualFile: string;
    productPrice: number;
    productRegDate: string;
    productLicenseLevel: number;
    history: any;
    handleDialogOpen: any;
    handleHelpClick: any;
}

const AddComma = (num: number) => {
    var regexp = /\B(?=(\d{3})+(?!\d))/g;
    return num.toString().replace(regexp, ',');
};

const ProductItem: React.FC<iProductItem> = (props) => {
    const classes = useStyles();
    const {
        productNum,
        productName,
        productImage,
        productMenualFile,
        productPrice,
        productRegDate,
        productLicenseLevel,
        history,
        handleDialogOpen,
    } = props;

    const goManuel = () => {
        history.push({
            pathname: `/manual`,
            state: { productMenualFile: productMenualFile },
        });
    };

    return (
        <Card className={classes.card} translate="no">
            <CardHeader
                className={classes.cardHeader}
                title={
                    <>
                        <Typography>{`Lv. ${productLicenseLevel} ${productName}`}</Typography>
                        <Typography id="price">{`판매가격 : ${AddComma(
                            productPrice
                        )}원`}</Typography>
                    </>
                }
            />
            <CardMedia
                className={classes.media}
                image={basic.server + '/displayImage?fileName=' + productImage}
            />
            <CardActions className={classes.cardAction}>
                <Button
                    onClick={goManuel}
                    variant="contained"
                    className={clsx(classes.button, classes.manualButton)}
                >
                    설명서보기
                </Button>
                <Button
                    onClick={props.handleHelpClick}
                    variant="contained"
                    className={clsx(classes.button, classes.manualButton)}
                >
                    재료 목록 보기
                </Button>
                {/* <Button onClick={handleDialogOpen} variant="contained" className={clsx(classes.button, classes.productionButton)}>
                    제품생산하기
                </Button> */}
            </CardActions>
        </Card>
    );
};

/*

                action={
                    //<Typography id="price">{`판매가격 : ${AddComma(productPrice)}원`}</Typography>
                    <IconButton aria-label="help" id="cardHelpIcon" onClick={props.handleHelpClick}>
                        <img src="images/help.webp" />
                    </IconButton>
                }
*/

export default ProductItem;
